<script lang="ts">
    import type { ElearningFile } from "../elearning.js";
    import { createBlobUrl } from "../elearning.js";
    import { VideoStream } from "./index.js";

    interface Props {
        file: ElearningFile;
        type: string;
    }

    let { file, type }: Props = $props();

    async function prepareMedia(file: ElearningFile) {
        if (file.is_remote) {
            return file.source;
        }

        return createBlobUrl(file.source);
    }
</script>


    {#await prepareMedia(file)}
        <p>Media se načítají...</p>
    {:then src}
        {#if file.is_remote}
            <VideoStream source={src} autoplay controls muted />
        {:else}
            <video class="max-h-80 w-auto" autoplay controls muted>
                <source {src} {type} />
            </video>
        {/if}
    {/await}

